import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

export const GET_STOREFRONT_COLLECTIONS = gql`
  query storefrontCollections {
    storefrontCollections {
      next
      items {
        id
        name
      }
    }
  }
`;

const useStorefrontCollections = () => {
  const { loading, error, data } = useQuery(GET_STOREFRONT_COLLECTIONS, {
    ssr: false,
    fetchPolicy: "no-cache",
  });

  return { loading, error, collections: data?.storefrontCollections?.items };
};

export { useStorefrontCollections };
